import { render } from "./CalibrationModal.vue?vue&type=template&id=2e989034&scoped=true"
import script from "./CalibrationModal.vue?vue&type=script&lang=js"
export * from "./CalibrationModal.vue?vue&type=script&lang=js"

import "./CalibrationModal.vue?vue&type=style&index=0&id=2e989034&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e989034"]])

export default __exports__